/*
 * SMParts — das gewaehlte Bike faehrt mit der Bestellung mit.
 *
 * Beim Legen in den Warenkorb bekommt der Artikel eine Zeile:
 *
 *     Motorrad: KTM · 125 EXC · 2016
 *
 * Sie steht danach im Warenkorb, an der Kasse, in der Bestaetigungsmail
 * und — darum geht es — in der Bestellung im Admin unter dem Artikel.
 * Bei Sonderanfertigungen wie Felgensaetzen oder Bremsscheiben ist das
 * die Angabe, ohne die nicht gefertigt werden kann; bei allem anderen
 * beantwortet sie spaeter "fuer welches Bike hat der das gekauft".
 *
 * Bewusst OHNE fuehrenden Unterstrich: eine Eigenschaft mit Unterstrich
 * gilt als intern und wird dem Kunden verborgen. Hier soll sie sichtbar
 * sein — er sieht im Warenkorb noch einmal, fuer welches Motorrad er
 * bestellt, und kann widersprechen, bevor gefertigt wird.
 *
 * WARUM DAS FELD DAUERHAFT IM FORMULAR STEHT
 *
 * Erst beim Absenden zu setzen waere sauberer, funktioniert hier aber
 * nicht: den Warenkorb bedient die App UpCart, und die feuert kein
 * submit-Ereignis. Sie liest die Felder des Formulars selbst aus und
 * baut ihre eigene Anfrage. Was beim Klick nicht schon im Formular
 * steht, geht verloren. Also steht es dauerhaft drin und wird
 * nachgefuehrt, sobald sich das Bike aendert.
 */
(function () {
  'use strict';

  var FELD = 'Motorrad';
  var MARKE = 'data-smp-bike-feld';
  var FORMULARE = 'form[action*="/cart/add"]';

  function beschriftung() {
    var bike = window.SMPBike ? window.SMPBike.read() : null;
    if (!bike) return '';
    return [bike.marke, bike.modell, bike.baujahr].filter(Boolean).join(' · ');
  }

  function pflegen(form, wert) {
    if (!form) return;
    var feld = form.querySelector('input[' + MARKE + ']');

    /* Kein Bike gewaehlt: gar keine Eigenschaft, nicht eine leere. */
    if (!wert) {
      if (feld && feld.parentNode) feld.parentNode.removeChild(feld);
      return;
    }

    if (!feld) {
      feld = document.createElement('input');
      feld.type = 'hidden';
      feld.setAttribute(MARKE, '');
      feld.name = 'properties[' + FELD + ']';
      form.appendChild(feld);
    }
    feld.value = wert;
  }

  function alle() {
    var wert = beschriftung();
    Array.prototype.forEach.call(document.querySelectorAll(FORMULARE), function (form) {
      pflegen(form, wert);
    });
  }

  /*
   * Formulare entstehen auch spaeter — Schnellkauf im Warenkorb,
   * empfohlene Produkte, der Theme-Editor baut Sections neu. Statt
   * das DOM dauerhaft zu beobachten, genuegt der Klick: in der
   * Erfassungsphase am Dokument laufen wir vor jedem Zuhoerer, der
   * tiefer im Baum haengt — also auch vor dem der Warenkorb-App.
   */
  document.addEventListener('click', function (e) {
    var ziel = e.target;
    if (!ziel || !ziel.closest) return;
    var form = ziel.closest(FORMULARE);
    if (form) pflegen(form, beschriftung());
  }, true);

  /* Dawns eigener Weg geht ueber submit — dort den Stand auffrischen. */
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches(FORMULARE)) {
      pflegen(e.target, beschriftung());
    }
  }, true);

  function start() {
    alle();
    if (window.SMPBike && window.SMPBike.onChange) window.SMPBike.onChange(alle);
    document.addEventListener('shopify:section:load', alle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
